export enum BadgeColors {
	SUCCESS = 'success',
	WARN = 'warn',
	ERROR = 'error',
	ERROR_RED = 'error-red'
}
